import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { WorkbookTooltip } from '../Tooltips/WorkbookTooltip';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, getContentUrlForItem } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { Thumbnail } from './Thumbnail';
import { doesTooltipNotHaveOwnerToDisplay } from '../Tooltips/Elements/Tooltip';
import { DraftTags } from '../../../drafts/components/DraftTags';
import { DraftTagsParentType } from '../../../drafts/types/DraftsTypes';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { isValidDraftStatus } from '../../../drafts/utils/DraftUtils';

export const WorkbookDefaultImageUrl = imgPath('spaces_card_workbook.svg');

export class WorkbookCard extends ContentCard {

  public render() {
    const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(this.props.content);
    const isValidDraft = isValidDraftStatus(this.props.content.draftStatus);

    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor
          tooltipContent={this.renderTooltipContent}
          width={DetailsTooltipStyles.Width}
          onShowTooltip={this.handleShowTooltip}
          title={Messages.workbookDetails()}
          disableAutoFocus={disableAutoFocus}
          disableTooltip={this.props.disableTooltip}
        >
          <Thumbnail navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
            defaultImageUrl={WorkbookDefaultImageUrl}
            thumbnailImageUrl={this.props.content.thumbnailUrl}
            decorate={true}
            allowDragAndDrop={this.props.allowDragAndDrop}
            hoveredOrSelected={this.props.hoveredOrSelected}
            draftStatus={this.props.content.draftStatus}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span data-tb-test-id="workbook-name" className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            { this.props.content.name }
          </span>
          {this.showFavoritesStar() && <span>
            <FavoriteToggle isTabbable={true}
                            isFavorite={this.props.content.favorite}
                            onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'workbook' })}
                            onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'workbook' })}/>
          </span>}
          { this.renderActionsMenu() }
        </div>
        <div className={CardViewStyles.CardDescription}>
          {isValidDraft ? this.getDescriptionWithDraft() : this.getDescription()}
        </div>
        {isValidDraft && this.renderDraftStatus(this.props.content.draftStatus, this.props.content.contentType)}
      </div>
    );
  }

  private renderTooltipContent = () => {
    return <WorkbookTooltip content={this.props.content}
                            urls={this.props.urls}
                            inProjectSpace={this.props.inProjectSpace}
                            inPersonalSpace={this.props.inPersonalSpace}
                            draftLastUpdatedTimeStamp={this.getDraftLastUpdatedAt(this.props.content.draftLuid)}/>;
  }

  private getDraftLastUpdatedAt = (draftLuid: string): string => {
    return this.doesDraftExist(draftLuid) && this.props.drafts[draftLuid].updatedAt;
  }

  private doesDraftExist = (draftLuid: string): boolean => {
    // In case that the draftLuid exists under the content but doesn't exist in the drafts' store.
    return this.props.content.draftLuid && this.props.drafts && draftLuid in this.props.drafts;
  }

  private renderDraftStatus(draftStatus: string, contentType: ExplorableItemType) {
    return (
      <DraftTags
        explorableItemType={contentType}
        draftStatus={draftStatus}
        parentType={DraftTagsParentType.card}>
      </DraftTags>
    );
  }
}
